import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export default class InvoiceStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "InvoiceStore",
      properties: [
        "allInvoices",
        "allInvoicesAnalysis",
        "selectedInvoice",
        "business",
      ],
    });
  }

  allInvoices = [];
  allInvoicesAnalysis = [];
  selectedInvoice = {};
  business = "";

  reset = () => {
    this.allInvoices = [];
    this.allInvoicesAnalysis = [];
    this.selectedInvoice = {};
    this.business = "";
  };

  setAllInvoices = async (state) => {
    runInAction(() => {
      this.allInvoices = state;
    });
  };

  setAllInvoicesAnalysis = async (state) => {
    runInAction(() => {
      this.allInvoicesAnalysis = state;
    });
  };

  setSelectedInvoice = async (state) => {
    runInAction(() => {
      this.selectedInvoice = state;
    });
  };
  setBusiness = async (state) => {
    runInAction(() => {
      this.business = state;
    });
  };
}
